import {
  DevHubBox,
  DevHubGrid,
  DevHubProgressBar,
  DevHubTypography,
} from '@devxdiscover/devhub-ui';
import { ExportStage } from '../types';
import { useCGAHierarchyStyles } from '../styles';

interface ExportProgressProps {
  progress: number;
  stage: ExportStage;
  appCount: number;
  isExporting: boolean;
}

/**
 * Export progress component showing a progress bar and stage information.
 * Displays only when export is in progress.
 * @param props - Component props
 * @param props.progress - Current export progress percentage (0-100)
 * @param props.stage - Current export stage
 * @param props.appCount - Number of applications being exported
 * @param props.isExporting - Whether export is in progress
 */
export const ExportProgress = ({
  progress,
  stage,
  appCount,
  isExporting,
}: ExportProgressProps) => {
  const classes = useCGAHierarchyStyles();

  if (!isExporting) {
    return null;
  }

  const getStageMessage = () => {
    switch (stage) {
      case 'graphql':
        return 'Loading devices & cloud accounts...';
      case 'cnap':
        return 'Loading CNAP data...';
      case 'finalizing':
        return 'Finalizing report...';
      default:
        return '';
    }
  };

  return (
    <DevHubBox className={classes.progressSection}>
      <DevHubGrid container spacing={1} alignItems="center">
        <DevHubGrid item xs>
          <DevHubTypography variant="body2" style={{ fontWeight: 500 }}>
            Exporting {appCount} application(s)... {progress}%
          </DevHubTypography>
          <DevHubTypography className={classes.progressStage}>
            {getStageMessage()}
          </DevHubTypography>
        </DevHubGrid>
      </DevHubGrid>
      <DevHubBox mt={1}>
        <DevHubProgressBar value={progress} size="small" />
      </DevHubBox>
    </DevHubBox>
  );
};
